import { render, staticRenderFns } from "./editor_chapter_require.vue?vue&type=template&id=488f38c9&scoped=true"
import script from "./editor_chapter_require.vue?vue&type=script&lang=js"
export * from "./editor_chapter_require.vue?vue&type=script&lang=js"
import style0 from "./editor_chapter_require.vue?vue&type=style&index=0&id=488f38c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f38c9",
  null
  
)

export default component.exports